import { Response as GetClientResponse } from 'api/typegen/client/get';
import { ROUTES } from 'utils/constants/constants_routes';

/** Before using this, check whether there's 'VITE_ENV' on Bitbucket => Repository Settings => Deployments Variables */
const isLogged = () => Boolean(sessionStorage.getItem('token'));

export const isLogging = () =>
  window.location.pathname === ROUTES.ONE_TIME_TOKEN_LOGIN_WAITING;

export const areClientEndpointsReadyToFetch = (
  client?: GetClientResponse | undefined | null,
) => (!isLogged() && !isLogging()) || client !== undefined;

export default isLogged;
